import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'jobPaths'

type TJobPath = {
  _id: string
  display: string
  jobs: string[]
  _firmId: string
  authorId?: string
}

const getFirm = (axios: IFactoryFunctionRequest<TJobPath | null, undefined>) => (firmId: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/firm/${firmId}`,
  })
}

const v2GetFirm = (axios: IFactoryFunctionRequest<TJobPath | null, undefined>) => () => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/firm`,
  })
}

const create = (axios: IFactoryFunctionRequest<TJobPath, Partial<TJobPath>>) => (data: Partial<TJobPath>) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    data,
  })
}

const update = (axios: IFactoryFunctionRequest<TJobPath, Partial<TJobPath>>) => (pathId: string, data: Partial<TJobPath>) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${pathId}`,
    data,
  })
}

export default (axios: AxiosInstance) => ({
  getFirm: getFirm(useAxios(axios)),
  v2GetFirm: v2GetFirm(useAxios(axios)),
  create: create(useAxios(axios)),
  update: update(useAxios(axios)),
})
